"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ProviderTabs_styles_1 = require("./ProviderTabs.styles");
const startCase_1 = __importDefault(require("lodash/startCase"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const tab_1 = require("@kyruus/tab");
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const framer_motion_1 = require("framer-motion");
const Content_1 = require("./Content");
const ShowLessButton_1 = require("./ShowLessButton");
const ProviderTabs_styles_2 = require("./ProviderTabs.styles");
const types_1 = require("../types");
const util_1 = require("../common/util");
const Training_1 = require("./Content/Training/Training");
const hasFocusableContent = (activeTab) => {
    // add new tabs with focusable content to the list below
    if (activeTab) {
        return ['locations', 'insurance', 'practiceGroups', 'training'].some((tab) => tab === activeTab);
    }
    return false;
};
const containerAnimationVariants = {
    open: {
        opacity: 1,
        height: 'auto',
        transition: {
            height: { duration: 0.1, type: 'tween' }
        }
    },
    close: {
        height: 0,
        transition: {
            height: { delay: 0.1, duration: 0.1 }
        }
    }
};
const childAnimationVariants = {
    initial: { opacity: 0 },
    open: {
        opacity: 1,
        height: 'auto',
        transition: {
            opacity: { delay: 0.1 }
        }
    },
    close: {
        opacity: 0,
        transition: {
            opacity: { duration: 0.1 }
        }
    }
};
const SUPPORTED_TABS = [
    'locations',
    'notes',
    'insurance',
    'practiceGroups',
    'clinicalKeywords',
    'training',
    'schedulingInstructions',
    'communication',
    'routing'
];
const SUPPORTED_NOTES_TABS = ['notes', 'communication', 'routing'];
const ProviderTabs = (props) => {
    const { labels: { tabsListLabel = (provider) => `Information Tabs for ${(0, util_1.getProviderDisplayName)(provider)}`, insuranceLabels, practiceGroupsLabels, locationsLabels, clinicalKeywordsLabels, trainingLabels, schedulingInstructionsLabels, tabularContentLabels } = {}, tabs = [], initialActiveTab, onActivate, provider, customerCode, productName, LocationsProps, PracticeGroupsProps, ClinicalKeywordsProps, TrainingProps, isLoading, getTableEventHandlers, onRichTextLinkClick } = props;
    const tabsToRender = (0, react_1.useMemo)(() => {
        return tabs
            .map((tab) => {
            var _a;
            if (typeof tab === 'string') {
                return {
                    id: (0, camelCase_1.default)(tab),
                    label: (0, startCase_1.default)(tab)
                };
            }
            return Object.assign(Object.assign({}, tab), { id: (0, camelCase_1.default)(tab.id), label: (_a = tab.label) !== null && _a !== void 0 ? _a : (0, startCase_1.default)(tab.id) });
        })
            .filter((tab) => tab.type === types_1.TAB_TYPE.TABLE ||
            SUPPORTED_TABS.includes(tab.id));
    }, [tabs]);
    const [activeTab, setActiveTab] = (0, react_1.useState)(initialActiveTab ? (0, camelCase_1.default)(initialActiveTab) : undefined);
    const shouldRenderTabularContent = (0, react_1.useCallback)(() => {
        const tabToRender = tabsToRender.find((tab) => tab.id === activeTab);
        return (tabToRender === null || tabToRender === void 0 ? void 0 : tabToRender.type) === 'table';
    }, [tabsToRender, activeTab]);
    const handleActivate = (0, react_1.useCallback)((_, tab) => {
        const currentActiveTab = activeTab;
        setActiveTab(tab);
        if (onActivate) {
            onActivate(currentActiveTab, tab, provider);
        }
    }, [activeTab, onActivate, provider]);
    const tabListRef = (0, react_1.useRef)(null);
    const handleClickShowLess = (0, react_1.useCallback)(() => {
        var _a, _b;
        setActiveTab(undefined);
        (_b = (_a = tabListRef === null || tabListRef === void 0 ? void 0 : tabListRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.focus();
    }, []);
    const { tabsA11yProps, tabPanelA11yProps } = (0, tab_1.useTabA11y)({
        labelText: tabsListLabel(provider),
        activeTabHasFocusableContent: shouldRenderTabularContent()
            ? true
            : hasFocusableContent(activeTab)
    });
    const handleRichTextLinkClick = (0, react_1.useCallback)((event, anchor) => {
        if (onRichTextLinkClick) {
            return onRichTextLinkClick(event, activeTab, anchor);
        }
    }, [activeTab, onRichTextLinkClick]);
    const getNotesFields = () => {
        var _a;
        const tabToRender = tabsToRender.find((curTab) => curTab.id === activeTab);
        if ((tabToRender === null || tabToRender === void 0 ? void 0 : tabToRender.type) === types_1.TAB_TYPE.NOTES) {
            return (_a = tabToRender.notes_fields) !== null && _a !== void 0 ? _a : [];
        }
        else
            return [];
    };
    const getTabularContentProps = () => {
        var _a, _b;
        const tabToRender = tabsToRender.find((tab) => tab.id === activeTab);
        return {
            columns: (_a = tabToRender === null || tabToRender === void 0 ? void 0 : tabToRender.columns) !== null && _a !== void 0 ? _a : [],
            path: (_b = tabToRender === null || tabToRender === void 0 ? void 0 : tabToRender.path) !== null && _b !== void 0 ? _b : ''
        };
    };
    const ShimmerBars = () => {
        return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "loader" },
            react_1.default.createElement(loaders_and_spinners_1.ShimmeringLoaderBar, { margin: '10px 0 10px 0' }),
            react_1.default.createElement(loaders_and_spinners_1.ShimmeringLoaderBar, { margin: '10px 0 10px 0' }),
            react_1.default.createElement(loaders_and_spinners_1.ShimmeringLoaderBar, { margin: '10px 0 10px 0' })));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(tab_1.DropdownTabs, Object.assign({ ref: tabListRef, tabs: tabsToRender, activeTab: activeTab, onActivate: handleActivate, elevation: 0 }, tabsA11yProps)),
        react_1.default.createElement(framer_motion_1.AnimatePresence, null, activeTab && (react_1.default.createElement(ProviderTabs_styles_2.ContentContainer, Object.assign({ key: 'ContentContainer', variants: containerAnimationVariants, initial: "close", animate: "open", exit: "close", "data-testid": "content-container" }, tabPanelA11yProps(activeTab)),
            isLoading && react_1.default.createElement(ShimmerBars, null),
            !isLoading && (react_1.default.createElement(framer_motion_1.motion.div, { variants: childAnimationVariants },
                activeTab === types_1.BASE_TAB.LOCATIONS && LocationsProps != null && (react_1.default.createElement(Content_1.Locations, Object.assign({ labels: locationsLabels, provider: provider, customerCode: customerCode }, LocationsProps))),
                SUPPORTED_NOTES_TABS.includes(activeTab) && (react_1.default.createElement(Content_1.Notes, { provider: provider, customerCode: customerCode, notesFields: getNotesFields(), onRichTextLinkClick: handleRichTextLinkClick })),
                activeTab === types_1.BASE_TAB.INSURANCE && (react_1.default.createElement(Content_1.Insurance, { labels: insuranceLabels, provider: provider, customerCode: customerCode, stateEventHandlers: getTableEventHandlers === null || getTableEventHandlers === void 0 ? void 0 : getTableEventHandlers(types_1.BASE_TAB.INSURANCE) })),
                activeTab === types_1.BASE_TAB.PRACTICE_GROUPS && (react_1.default.createElement(Content_1.PracticeGroups, Object.assign({ labels: practiceGroupsLabels, provider: provider, customerCode: customerCode, productName: productName }, PracticeGroupsProps))),
                activeTab === types_1.BASE_TAB.CLINICAL_KEYWORDS && (react_1.default.createElement(Content_1.ClinicalKeywords, Object.assign({ labels: clinicalKeywordsLabels, provider: provider, customerCode: customerCode, productName: productName, stateEventHandlers: getTableEventHandlers === null || getTableEventHandlers === void 0 ? void 0 : getTableEventHandlers(types_1.BASE_TAB.CLINICAL_KEYWORDS) }, ClinicalKeywordsProps))),
                activeTab === types_1.BASE_TAB.TRAINING && (react_1.default.createElement(Training_1.Training, Object.assign({ labels: trainingLabels, provider: provider, customerCode: customerCode, stateEventHandlers: getTableEventHandlers === null || getTableEventHandlers === void 0 ? void 0 : getTableEventHandlers(types_1.BASE_TAB.TRAINING) }, TrainingProps))),
                activeTab === types_1.BASE_TAB.SCHEDULING_INSTRUCTIONS && (react_1.default.createElement(Content_1.SchedulingInstructions, { labels: schedulingInstructionsLabels, provider: provider, customerCode: customerCode, onRichTextLinkClick: handleRichTextLinkClick })),
                shouldRenderTabularContent() && (react_1.default.createElement(Content_1.TabularContent, Object.assign({ labels: tabularContentLabels, provider: provider, customerCode: customerCode, stateEventHandlers: getTableEventHandlers === null || getTableEventHandlers === void 0 ? void 0 : getTableEventHandlers(activeTab) }, getTabularContentProps()))))),
            react_1.default.createElement(framer_motion_1.motion.div, { variants: childAnimationVariants },
                react_1.default.createElement(ShowLessButton_1.ShowLessButton, { onClick: handleClickShowLess })))))));
};
exports.default = ProviderTabs;
//# sourceMappingURL=ProviderTabs.js.map